export { Record as default } from 'choerodon-ui/dataset';
